export const GET_ALERTS = 'GET_ALERTS';
export const GET_ALERTS_START = `${GET_ALERTS}_START`;
export const GET_ALERTS_SUCCESS = `${GET_ALERTS}_SUCCESS`;
export const GET_ALERTS_FAIL = `${GET_ALERTS}_FAIL`;

export const GET_ALERTS_FETCH_MORE = 'GET_ALERTS_FETCH_MORE';
export const GET_ALERTS_FETCH_MORE_START = `${GET_ALERTS_FETCH_MORE}_START`;
export const GET_ALERTS_FETCH_MORE_SUCCESS = `${GET_ALERTS_FETCH_MORE}_SUCCESS`;
export const GET_ALERTS_FETCH_MORE_FAIL = `${GET_ALERTS_FETCH_MORE}_FAIL`;

export const GET_ALERTS_COUNT = 'GET_ALERTS_COUNT';
export const GET_ALERTS_START_COUNT = `${GET_ALERTS_COUNT}_START`;
export const GET_ALERTS_SUCCESS_COUNT = `${GET_ALERTS_COUNT}_SUCCESS`;
export const GET_ALERTS_FAIL_COUNT = `${GET_ALERTS_COUNT}_FAIL`;

export function getAlerts(params) {
  return {
    type: `GET_ALERTS${
      params.offset > 0 || params.bqOffset > 0 ? '_FETCH_MORE' : ''
    }`,
    meta: {
      xmApi: true,
      method: 'get',
      uri: `/webapi/abe/1/events`,
      params: {
        limit: 100,
        offset: 0,
        ...params,
      },
    },
  };
}

export function getAlertsCount(params) {
  return {
    type: GET_ALERTS_COUNT,
    meta: {
      xmApi: true,
      method: 'get',
      uri: `/webapi/abe/1/events`,
      params: {
        limit: 0,
        offset: 0,
        ...params,
      },
    },
  };
}
